<template>
  <div>
    <p class="winston">
      "The further backward you look, the further forward you can see" –
      W.Churchill
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
